import React, { useState } from 'react';
import { StarIcon, CheckCircleIcon, PencilIcon } from 'lucide-react';
import { trackCustom } from '../utils/tracking';
export function WriteReview() {
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(5);
  const [name, setName] = useState('');
  const [trade, setTrade] = useState('');
  const [body, setBody] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    trackCustom('review_submitted', {
      rating
    });
    setSubmitted(true);
  };
  if (submitted) {
    return <div className="mt-10 flex flex-col items-start gap-4 border-2 border-grit-500 bg-grit-500/10 p-6 sm:flex-row sm:items-center sm:p-8" data-id="element-1643" data-mp="1ohoficv78r9w">
        <CheckCircleIcon className="h-10 w-10 shrink-0 text-grit-500" aria-hidden="true" data-id="element-1644" data-mp="1thtzr7z53bhy" />
        <div data-id="element-1645" data-mp="3ivfjowureixy">
          <p className="font-display text-2xl font-extrabold uppercase leading-none text-grit-500 sm:text-3xl" data-id="element-1646" data-mp="3isteh3vccfiw">
            Thanks for your review
          </p>
          <p className="mt-2 text-[15px] text-steel-200" data-id="element-1647" data-mp="eshze9bwxfmf">
            Your review has been submitted and is being verified. Once verified it joins the 18,412 reviews from
            tradespeople across America. Thanks for helping the next crew decide.
          </p>
        </div>
      </div>;
  }
  return <div className="mt-10 border border-white/12 bg-ink-950 p-6 sm:p-8" data-id="element-1648" data-mp="jl2pp0vm1al7">
      {!open ? <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-1649" data-mp="3s14cgork6t4h">
          <div data-id="element-1650" data-mp="3o0bzpljha63g">
            <p className="font-display text-2xl font-extrabold uppercase leading-none text-offwhite sm:text-3xl" data-id="element-1651" data-mp="3o0u5p9vxzyok">
              Own an X1? Leave a review.
            </p>
            <p className="mt-2 text-[15px] text-steel-400" data-id="element-1652" data-mp="t9ztfbu85hp">
              Tell the next mechanic, electrician or driver what it did for your day.
            </p>
          </div>
          <button type="button" onClick={() => setOpen(true)} className="flex w-full items-center justify-center gap-2 border-2 border-grit-500 px-6 py-4 font-display text-xl font-extrabold uppercase tracking-wide text-grit-500 transition-[background-color,color,transform] duration-150 ease-grit hover:bg-grit-500 hover:text-ink-950 active:translate-y-[2px] sm:w-auto" data-id="element-1653" data-mp="1c9zv43eq3cwj">
            <PencilIcon className="h-5 w-5" aria-hidden="true" data-id="element-1654" data-mp="1y8co7sfxag4k" />
            Write a review
          </button>
        </div> : <form onSubmit={handleSubmit} data-id="element-1655" data-mp="10k2ip3gxha8p">
          <p className="font-display text-2xl font-extrabold uppercase leading-none text-offwhite sm:text-3xl" data-id="element-1656" data-mp="15k8fey221mxn">
            Write your review
          </p>

          <fieldset className="mt-6" data-id="element-1657" data-mp="1ai099xm9fj4h">
            <legend className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-1658" data-mp="1fbbc7nnybfr4">Your rating</legend>
            <div className="mt-2 flex items-center gap-1.5" data-id="element-1659" data-mp="hue5opd18ehm">
              {[1, 2, 3, 4, 5].map(value => <button key={value} type="button" onClick={() => setRating(value)} aria-label={`${value} star${value > 1 ? 's' : ''}`} aria-pressed={rating === value} className="p-1 transition-transform duration-150 ease-grit active:translate-y-[1px]" data-id="element-1660" data-mp="mt7fo7t41nd1">
                  <StarIcon className={`h-8 w-8 ${value <= rating ? 'fill-grit-500 text-grit-500' : 'text-steel-500'}`} aria-hidden="true" data-id="element-1661" data-mp="eicmanxrus4" />
                </button>)}
            </div>
          </fieldset>

          <div className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-1662" data-mp="3irgdqkwgstnv">
            <label className="block" data-id="element-1663" data-mp="3irzpfjviultg">
              <span className="block text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-1664" data-mp="3dsvb6etqpxw9">Name</span>
              <input type="text" required value={name} onChange={event => setName(event.target.value)} placeholder="Mike R." className="mt-2 w-full border border-white/15 bg-ink-900 px-4 py-3 text-[15px] text-offwhite placeholder:text-steel-500 focus:border-grit-500 focus:outline-none" data-id="element-1665" data-mp="38ts6wwll3vpc" />
            </label>
            <label className="block" data-id="element-1666" data-mp="3kphqted5igc8">
              <span className="block text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-1667" data-mp="3kogez7ob9ptg">
                Trade &amp; state
              </span>
              <input type="text" value={trade} onChange={event => setTrade(event.target.value)} placeholder="Diesel mechanic · Texas" className="mt-2 w-full border border-white/15 bg-ink-900 px-4 py-3 text-[15px] text-offwhite placeholder:text-steel-500 focus:border-grit-500 focus:outline-none" data-id="element-1668" data-mp="3arbs15mn5qbl" />
            </label>
          </div>

          <label className="mt-4 block" data-id="element-1669" data-mp="zxxr1n16f2fg">
            <span className="block text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-1670" data-mp="1425hbona8qfs">Your review</span>
            <textarea required rows={4} value={body} onChange={event => setBody(event.target.value)} placeholder="What job were you on, and what did the X1 change?" className="mt-2 w-full resize-y border border-white/15 bg-ink-900 px-4 py-3 text-[15px] text-offwhite placeholder:text-steel-500 focus:border-grit-500 focus:outline-none" data-id="element-1671" data-mp="2okprn85k6tor" />
          </label>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-1672" data-mp="389i0kvl0ni0p">
            <button type="submit" className="flex w-full items-center justify-center bg-grit-500 px-6 py-4 font-display text-xl font-extrabold uppercase tracking-wide text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px] sm:w-auto" data-id="element-1673" data-mp="33aop18pai136">
              Submit review
            </button>
            <button type="button" onClick={() => setOpen(false)} className="text-sm font-bold uppercase tracking-wide text-steel-400 transition-colors duration-150 ease-grit hover:text-offwhite" data-id="element-1674" data-mp="1hx2dfsq9l398">
              Cancel
            </button>
          </div>
          <p className="mt-3 text-[13px] text-steel-500" data-id="element-1675" data-mp="3rxrgvpzp8r4u">
            Reviews are verified before they appear. Only first name and last initial are shown.
          </p>
        </form>}
    </div>;
}